module.exports = __webpack_public_path__ + "static/img/givelike.7cf246f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/givelike.png
// module id = sKcN
// module chunks = 4